import { Form, Input, Select } from '@arco-design/web-react';

import { formJsonFieldFormatter, formJsonFieldNormalize } from '@/delivery-type-plugin/capabilities/maas-init/utils/jsonFormField';
import { MODEL_CATEGORY_FORM_FIELD } from '@/delivery-type-plugin/capabilities/maas-model-storage/modelCategory';
import { MODEL_CAPABILITY_OPTIONS } from '@/types/model-capabilities';

const FormItem = Form.Item;

/**
 * StepForm 模型步骤内始终挂载：登记 model.sources / 弹窗草稿 model.* / _modelCategory，
 * 避免仅弹窗内 Form.Item 注册时，编辑态未打开弹窗提交丢失模型数据。
 */
export function MaasModelPersistFields() {
  return (
    <>
      <FormItem
        field="model.sources"
        hidden
        style={{ display: 'none', margin: 0 }}
        triggerPropName="value"
        formatter={formJsonFieldFormatter}
        normalize={formJsonFieldNormalize}
      >
        <Input />
      </FormItem>
      <FormItem field="model.name" hidden style={{ display: 'none', margin: 0 }}>
        <Input />
      </FormItem>
      <FormItem field="model.size" hidden style={{ display: 'none', margin: 0 }}>
        <Input />
      </FormItem>
      <FormItem field={MODEL_CATEGORY_FORM_FIELD} hidden style={{ display: 'none', margin: 0 }}>
        <Select mode="multiple" options={MODEL_CAPABILITY_OPTIONS} />
      </FormItem>
      <FormItem
        field="model.source"
        hidden
        style={{ display: 'none', margin: 0 }}
        triggerPropName="value"
        formatter={formJsonFieldFormatter}
        normalize={formJsonFieldNormalize}
      >
        <Input />
      </FormItem>
      <FormItem field="_modelStorageMode" hidden style={{ display: 'none', margin: 0 }}>
        <Input />
      </FormItem>
    </>
  );
}

export default MaasModelPersistFields;
